import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { ConfigRequestsInterface } from '../../interfaces/config-requests.interface';
import { InitializableInterface } from '../../interfaces/initializable.interface';
import { UriUtilitiesService } from '../uri-utilities/uri-utilities.service';

@Injectable({
    providedIn: 'root',
})
export class ConfigInterfaceService implements ConfigRequestsInterface, InitializableInterface {
    public isInitialized = false;
    public offlineStoreDefiningRequests: string[];

    private readonly commonEndpoints: string[];
    public constructor(private readonly uriUtilities: UriUtilitiesService) {
        this.commonEndpoints = [
            this.uriUtilities.appendParameter(
                ENDPOINTS.NotificationHeaders,
                this.uriUtilities.getNotificationHeaderByAppId(),
            ),
            ENDPOINTS.ValueHelpers,
            ENDPOINTS.ConfigSet,
            ENDPOINTS.InputFieldProperties,
            ENDPOINTS.WhatsNew,
        ];
    }

    public init(): Observable<string[]> {
        this.offlineStoreDefiningRequests = this.commonEndpoints;

        this.isInitialized = true;

        return of(this.offlineStoreDefiningRequests);
    }
}
